exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dashboard-inner-menu-container[data-v-856352d2]{max-width:calc(100vw - 620px)!important}.nav-tooltip[data-v-856352d2]{font-size:14px}", ""]);

// exports
